import { useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { ROUTEPATHS } from './routes/routePaths';
import { useStoreState } from 'pullstate';
import DslStore from './store/DslStore';
import { getStrapiPaths } from './store/Selectors';
import SignupPage from './routes/SignupPage';
import GenericStrapi from './routes/GenericStrapi';
import Library from './routes/library';
import Typography from './routes/typography';
import Images from './routes/images';
import Buttons from './routes/buttons';
import Cards from './routes/cards';
import Forms from './routes/forms';
import Components from './routes/components';
import Community from './routes/community';
import Partners from './routes/partners';
import CommunitySearch from './routes/communitySearch';
import Home from './routes/Home';
import PageNotFound from './routes/PageNotFound';
import ContactUs from './routes/ContactUs';
import ChooseUsername from './routes/chooseUsername';
import SearchResults from './routes/SearchResults';
import StrapiPage from './routes/StrapiPage';
import ContestListWLF from './routes/contest/ContestListWLF';
import LoginPage from './routes/LoginPage';
import ContestSkeletonWLF from './routes/contest/ContestSkeletonWLF';
import ProfileMain from './routes/profile/ProfileMain';
import ResetActivate from './routes/ResetActivate';

const Container = () => {
  const strapiPath = useStoreState(DslStore, getStrapiPaths);
  const [strapiMenu, setStrapiMenu] = useState(['']);

  useEffect(() => {
    let tempMenu: string[] = [];
    // console.log(strapiPath);
    strapiPath.map((item: string) => tempMenu.push(item.replace('/', '')));
    setStrapiMenu(tempMenu);
    console.log(tempMenu);
  }, [strapiPath]);

  console.log(strapiPath);
  console.log(strapiMenu);

  return (
    <Routes>
      <Route path={ROUTEPATHS.HOME} element={<Home />} />
      <Route path="/resetpass/:token" element={<ResetActivate />} />

      <Route path={ROUTEPATHS.CONTACT_US} element={<ContactUs />} />
      <Route path={ROUTEPATHS.SIGNUP} element={<SignupPage />} />
      <Route path={`${ROUTEPATHS.SIGNUP}/:huntercode`} element={<SignupPage />} />
      <Route path={`${ROUTEPATHS.CHOOSEUSERNAME}`} element={<ChooseUsername />} />

      <Route path={ROUTEPATHS.SIGNIN} element={<LoginPage />} />

      {/* Component Library */}
      <Route path={ROUTEPATHS.LIBRARY} element={<Library />} />
      <Route path={ROUTEPATHS.TYPOGRAPHY} element={<Typography />} />
      <Route path={ROUTEPATHS.IMAGES} element={<Images />} />
      <Route path={ROUTEPATHS.BUTTONS} element={<Buttons />} />
      <Route path={ROUTEPATHS.CARDS} element={<Cards />} />
      <Route path={ROUTEPATHS.FORMS} element={<Forms />} />
      <Route path={ROUTEPATHS.COMPONENTS} element={<Components />} />

      {/* Main pages */}
      <Route path={ROUTEPATHS.COMMUNITY} element={<Community />} />

      {/* Contest */}
      <Route path={ROUTEPATHS.CONTEST} element={<ContestListWLF />} />
      {/* Design */}

      <Route path={`${ROUTEPATHS.CONTEST}/:nameForURL/`} element={<ContestSkeletonWLF />} />
      <Route path={`${ROUTEPATHS.CONTEST}/:nameForURL/:pageName`} element={<ContestSkeletonWLF />} />
      <Route path={`${ROUTEPATHS.CONTEST}/:nameForURL/:pageName/:designName`} element={<ContestSkeletonWLF />} />

      {/* Creatives */}
      <Route path={ROUTEPATHS.INFO_CREATIVES_PARTNERS} element={<Partners />} />

      {/* Community */}

      <Route path={`${ROUTEPATHS.USER}/:username/`} element={<ProfileMain />} />
      <Route path={`${ROUTEPATHS.USER}/:username/${ROUTEPATHS.COMMUNITY_PROFILE_PREVIEW}`} element={<ProfileMain isPreview={true} />} />
      <Route path={`${ROUTEPATHS.USER}/:username/:pageName`} element={<ProfileMain />} />
      <Route path={`${ROUTEPATHS.USER}/:username/:pageName/:designName`} element={<ProfileMain />} />

      <Route path={`${ROUTEPATHS.CLIENT}/:username/`} element={<ProfileMain />} />
      <Route path={`${ROUTEPATHS.CLIENT}/:username/${ROUTEPATHS.COMMUNITY_PROFILE_PREVIEW}`} element={<ProfileMain isPreview={true} />} />
      <Route path={`${ROUTEPATHS.CLIENT}/:username/:pageName`} element={<ProfileMain />} />

      <Route path={`${ROUTEPATHS.COMMUNITY}/:username/`} element={<ProfileMain />} />
      <Route path={`${ROUTEPATHS.COMMUNITY}/:username/${ROUTEPATHS.COMMUNITY_PROFILE_PREVIEW}`} element={<ProfileMain isPreview={true} />} />
      <Route path={`${ROUTEPATHS.COMMUNITY}/:username/:pageName`} element={<ProfileMain />} />

      <Route path={`${ROUTEPATHS.COMMUNITY}${ROUTEPATHS.COMMUNITY_SEARCH}`} element={<CommunitySearch />} />

      {/* Client */}
      {/* <Route path={`${ROUTEPATHS.COMMUNITY}/:username/${ROUTEPATHS.CLIENT_CONTESTS}`} element={<ClientContest />} /> */}

      {/* Designer */}

      <Route path={`/Search`} element={<SearchResults />} />
      <Route path={`/Search/community`} element={<SearchResults />} />
      <Route path={`/Search/design`} element={<SearchResults />} />
      <Route path={`/Search/contest`} element={<SearchResults />} />
      {/* Unknown path */}
      {strapiPath.map((item: string, index: number) => (
        <Route path={`${item}/*`} element={<StrapiPage />} key={index}>
          {/* {strapiMenu.map((menu: string, index: number) => (
            <Route path={`${menu}`} element={<GenericStrapi />} key={index}>
              <Route path={`*`} element={<GenericStrapi />} />
            </Route>
          ))} */}
        </Route>
      ))}

      {/* <Route path={`/PageNotFound`} element={<PageNotFound />} /> */}
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};
export default Container;
